import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress, Table, TableHead, TableBody, TableCell, TableRow, Box, Pagination } from "@mui/material";
import commonStyles from "../../styles/Common.module.css";
import moment from "moment";

const SearchHistoryUsersPage = () => {
    const { state } = useLocation();
    const { companyId, company_name, count } = state || {};

    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 50;

    useEffect(() => {
        const fetchUsers = async () => {
            setIsLoading(true);
            try {
                const res = await fetch(`https://api.sovrenn.com/search-history/users-list/${companyId}?page=${page}&page_size=${pageSize}`, {
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("sov_user")
                    }
                });
                const result = await res.json();
                if (result.success) {
                    const sorted = (result.data || []).sort((a, b) => new Date(b.lastSearchedAt) - new Date(a.lastSearchedAt));
                    setUsers(sorted);
                    setTotalPages(result.pagination?.total_pages || 1);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        if (companyId) fetchUsers();
        else setIsLoading(false);
    }, [companyId, page]);
   

    return (
        <div className={commonStyles.MainContainer}>
            <div className={commonStyles.headerDiv}>
                <h2>{company_name}</h2>
                <p>Total Searches: <strong>{count}</strong></p>
            </div>

            {isLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", margin: "100px auto", width: 100 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ fontWeight: "bold" }}>#</TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>Email</TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>Phone Number</TableCell>
                                 <TableCell style={{ fontWeight: "bold" }}>Search Count</TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>Last Searched At</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map((user, ind) => (
                                <TableRow key={user.user_id || ind}>
                                    <TableCell>{(page - 1) * pageSize + ind + 1}</TableCell>
                                    <TableCell>{user.name}</TableCell>
                                    <TableCell>{user.email}</TableCell>
                                    <TableCell>{user.phone_number}</TableCell>
                                     <TableCell>{user.searchCount}</TableCell>
                                    <TableCell>{moment(user.lastSearchedAt).format("Do MMM YYYY, hh:mm A")}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(event, value) => setPage(value)}
                        color="primary"
                        style={{ marginTop: "20px" }}
                    />
                </>
            )}
        </div>
    );
};

export default SearchHistoryUsersPage;
